var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loader'):_c('ibi-content-page')
}
var staticRenderFns = []

export { render, staticRenderFns }